import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'
import lodash from 'lodash'
window._ = lodash
Vue.prototype._ = lodash

// import './components/editor/assets/sass/variables.scss'
// import './components/editor/assets/sass/'

import '~/plugins'
import '~/components'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
import "vue-multiselect/dist/vue-multiselect.min.css"

Vue.config.productionTip = false

window.$ = window.jQuery = require('jquery');

// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min.js')

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/js/app.js